var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreciseLocationSsUnselected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 43,
    viewBox: "0 0 30 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.0086 14.7143C29.0086 20.2 19.6724 34.5238 15.0043 41C10.4659 34.3968 0.999783 20.4286 1 14.7143C1.00025 8.2269 6.05711 1 15.0043 1C23.9515 1 29.0086 7.85714 29.0086 14.7143Z",
    fill: "#1D2943",
    stroke: "#1D2943",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 23C17.8472 23 19.9722 22.0486 21.5104 20.5104L18.682 17.682C17.8676 18.4963 16.7426 19 15.5 19C13.0147 19 11 16.9853 11 14.5C11 12.0147 13.0147 10 15.5 10C16.7426 10 17.8676 10.5037 18.682 11.318L21.5104 8.48959C19.9722 6.95139 17.8472 6 15.5 6C10.8056 6 7 9.80558 7 14.5C7 19.1944 10.8056 23 15.5 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreciseLocationSsUnselected);
export default __webpack_public_path__ + "static/media/precise-location-ss-unselected.6ba78531b5b637d5f0bc3277530447ab.svg";
export { ForwardRef as ReactComponent };